export function buildEmailHtml(
    title: string,
    fields: { label: string; value: string }[]
) {
    const rows = fields
        .map(
            (f) => `
      <tr>
        <td style="padding:6px 12px;font-weight:600;color:#241E18;white-space:nowrap;">${f.label}</td>
        <td style="padding:6px 12px;color:#3a332c;">${f.value || "—"}</td>
      </tr>`
        )
        .join("");

    return `
    <div style="font-family:Arial,sans-serif;max-width:600px;">
      <h2 style="color:#A9884F;border-bottom:1px solid #eee;padding-bottom:8px;">${title}</h2>
      <table style="border-collapse:collapse;width:100%;">${rows}</table>
    </div>
  `;
}